import { createContext } from '@berlin-front/common/composables/context';
import { UsablePatternsSplitTimesEnum } from '@netprotections/berlin-bff';
import { UnwrapRef } from '@vue/composition-api';

export const MESSAGE_COMMISSION_FREE = '分割手数料無料';
export const SPLIT_PATTERN_ONE = 'ONE';
export type SplitPattern = UsablePatternsSplitTimesEnum | typeof SPLIT_PATTERN_ONE;

export type UsablePattern = {
  // 支払い回数のパターン
  splitPattern: SplitPattern;
  // 支払い回数
  splitTimes: number;
  // 1回あたりの支払い金額
  splitAmount: number;
  // メッセージ（分割払いの場合は「分割手数料無料」と表示する）
  message?: string;
};

export type SelectPaymentMethodContextType = {
  useSelectPaymentMethod: () => UnwrapRef<{
    // 商品合計金額
    itemTotalAmount: number;
    // 支払い回数のパターン
    usablePatterns: UsablePattern[];
    // 選択されたパターン
    selectedPattern: UsablePattern;
    // ユーザ名（フッターにユーザ名と「ログアウト」ボタンを表示する）
    memberName: string;
    // 「次へ」押下時のアクション
    next: () => void;
  }>;
};

export const SelectPaymentMethodContext = createContext<SelectPaymentMethodContextType>(
  {} as SelectPaymentMethodContextType,
);
